import script from "./deviceAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./deviceAdd.vue?vue&type=script&setup=true&lang=js"

import "./deviceAdd.vue?vue&type=style&index=0&id=f566362e&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f566362e"]])

export default __exports__